import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthorizeGuard } from '../api-authorization/authorize.guard';
import { LoginComponent } from '../api-authorization/login/login.component';
import { DashboardComponent } from './cms-admin/dashboard/dashboard.component';
import { NoticeListComponent } from './notice-list/notice-list.component';
import { EventListComponent } from './event-list/event-list.component';

const routes: Routes = [
  //{ path: '', component: HomeComponent, pathMatch: "full" },
  { path: '', redirectTo: 'admin', pathMatch: "full" },
  { path: 'admin', loadChildren: './cms-admin/cms-admin.module#CmsAdminModule', canActivate: [AuthorizeGuard] },
  { path: 'facility', loadChildren: './cms-facility/cms-facility.module#CmsFacilityModule', canActivate: [AuthorizeGuard] },
  { path: 'notice', component: NoticeListComponent, pathMatch: "full" },
  { path: 'event', component:  EventListComponent, pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
